import React, { useState } from 'react';
import styled from 'styled-components';
import tr from 'locale';
import PayPalButton from '../../../../../elements/PaypalButton';
import {
  licenseActionSuccess,
  licenseBuyAction,
  upgradeLicenseAction,
  upgradeGroupLicenseAction,
} from '../../../../../../store/licenseBuy/actions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfile } from '../../../../../../store/clientdata/actions';

const ErrorText = styled.div`
  margin: 8px 0 0;
  color: #c62828;
  font: ${({ theme }) => theme.font.s};
`;

function PayPaypal(props) {
  const { disabled, toBuyProducts, platform, toUpgradeId, checkoutType } = props;
  const isSubscribe = checkoutType === 'subscriptions';

  const dispatch = useDispatch();
  const promocode = useSelector(state => state.basket.validatePromocode.promocode);
  const [error, setError] = useState(null);

  const createOrder = (data, actions) => {
    if (checkoutType === 'upgrade') {
      return dispatch(upgradeLicenseAction(toUpgradeId, { paymentMethod: 'paypal', platform }));
    } else if (checkoutType === 'upgrade-y') {
      return dispatch(
        upgradeGroupLicenseAction(toUpgradeId, { paymentMethod: 'paypal', platform })
      );
    } else {
      return dispatch(
        licenseBuyAction(toBuyProducts, { platform, paymentMethod: 'paypal', promocode })
      );
    }
  };

  const createSubscription = (data, actions) => {
    return dispatch(
      licenseBuyAction(toBuyProducts, {
        platform,
        paymentMethod: 'paypal',
        isSubscribe: true,
        promocode,
      })
    );
  };

  return (
    <>
      <PayPalButton
        createOrder={() => createOrder().then(response => response.payment.provider_data.order_id)}
        createSubscription={
          isSubscribe
            ? () =>
                createSubscription().then(response => response.payment.provider_data.subscription_id)
            : undefined
        }
        onApprove={() => {
          setError(null);
          // same as licenseBuyAction success behavior
          dispatch(fetchProfile());
          dispatch(licenseActionSuccess());
        }}
        onError={reason => {
          console.error('PayPaypal.js: ', reason);
          setError(tr('paypal_fulfill_error'));
        }}
        platform={platform}
        disabled={disabled}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </>
  );
}

export default PayPaypal;
